import { Agenda } from '../translations-types';

const translations: Agenda = {
  title: 'Agenda',
  today: 'Vandaag',
  allEmployees: 'Alle medewerkers',
  prepCard: 'Open voorbereidingskaart',
  noCalendar: 'Geen agenda gekoppeld',
  noAppointments: 'Geen afspraken',
  noAppointmentsHint: 'Geen afspraken — synchroniseer eerst in Instellingen → Salonized.',
  employee: 'Medewerker',
  unknownEmployee: 'Onbekend',
  attendees: 'Deelnemers',
};

export default translations;
